export const url = {
  home: "/",
  residential: "/Residential",
  services: "/Services",
  clients: "/Clients",
  ourclients: "/OurClients",
  architech: "/architech",
  Contact: "/Contact",
  standards: "/Standards",
  expertise: "/Expertise",
  formwork: "/Formwork",
  technology: "/Technology",
  management: "/Management",
  whoweare: "/Whoweare",
  award: "/Award",
  csr: "/Csr",
  commercial: "/Commercial",
  institutionalprojects: "/Institutionalprojects",
  industrial: "/Industrial",
  gallery: "/Gallery",
  jobsearch: "/JobSearch",
  machinery: "/Machinery",
  investorsInformation: "/InvestorInformation",
  annualreturns: "/AnnualReturns",
  policystatutoryInfo: "/PolicyStatutoryInfo",
  videos: "/Videos",
  lifeathitech: "/LifeAtHitech",
  admin: "/admin",
  adminApplications: "/admin/applications",
};
